import { ClassSession, EnrolledStudent } from 'modules/arena/class-groups/types';
import { Badge } from 'shared/components/ui/Badge';
import { Button } from 'shared/components/ui/Button';

interface AttendanceSessionCardProps {
  session: ClassSession;
  students: EnrolledStudent[];
  isExpanded: boolean;
  onToggleExpand: () => void;
  onTogglePresence: (studentId: string) => void;
  onSave: () => void;
}

export function AttendanceSessionCard({
  session,
  students,
  isExpanded,
  onToggleExpand,
  onTogglePresence,
  onSave,
}: AttendanceSessionCardProps) {
  return (
    <div className="rounded-xl border border-border/40 p-3">
      <div className="flex items-center justify-between">
        <div>
          <p className="text-sm font-medium text-ink">{session.dateLabel}</p>
          <p className="text-xs text-ink-secondary">{session.timeLabel}</p>
        </div>

        {session.attendanceTaken ? (
          <Badge tone="success">
            {session.presentStudentIds.length}/{students.length} presentes
          </Badge>
        ) : (
          <Button variant="ghost" className="px-3 py-1 text-xs" onClick={onToggleExpand}>
            {isExpanded ? 'Fechar' : 'Lançar presença'}
          </Button>
        )}
      </div>

      {!session.attendanceTaken && isExpanded && (
        <div className="mt-3 flex flex-col gap-2 border-t border-border/40 pt-3">
          {students.map((student) => (
            <label key={student.id} className="flex items-center gap-2 text-sm text-ink">
              <input
                type="checkbox"
                checked={session.presentStudentIds.includes(student.id)}
                onChange={() => onTogglePresence(student.id)}
                className="accent-primary"
              />
              {student.name}
            </label>
          ))}

          <Button className="mt-2 w-full" onClick={onSave}>
            Salvar presença
          </Button>
        </div>
      )}
    </div>
  );
}
